import { useState } from 'react';
import { TemporaryLocation, TemporaryLocationWithFriend, TemporaryLocationFormData } from '../../../types';

/**
 * Hook to manage temporary locations state
 */
export const useTempLocations = () => {
  // Temporary locations data
  const [tempLocations, setTempLocations] = useState<TemporaryLocationWithFriend[]>([]);
  const [myTempLocations, setMyTempLocations] = useState<TemporaryLocation[]>([]);

  // Modal state
  const [showTempLocationModal, setShowTempLocationModal] = useState(false);

  // Form data
  const [tempLocationData, setTempLocationData] = useState<TemporaryLocationFormData>({
    latitude: 0,
    longitude: 0,
    type: 'other',
    visibility_type: 'all',
    visible_group_ids: [],
    visible_friend_ids: [],
  });

  // Location selection
  const [isSelectingLocation, setIsSelectingLocation] = useState(false);
  const [previewMarkerPosition, setPreviewMarkerPosition] = useState<[number, number] | null>(null);

  // Date mode
  const [dateMode, setDateMode] = useState<'day' | 'datetime'>('datetime');

  // Blacklist
  const [blacklistedFriendIds, setBlacklistedFriendIds] = useState<number[]>([]);
  const [blacklistSearchQuery, setBlacklistSearchQuery] = useState('');
  const [showBlacklist, setShowBlacklist] = useState(false);

  return {
    // Temporary locations
    tempLocations,
    setTempLocations,
    myTempLocations,
    setMyTempLocations,

    // Modal
    showTempLocationModal,
    setShowTempLocationModal,

    // Form data
    tempLocationData,
    setTempLocationData,

    // Location selection
    isSelectingLocation,
    setIsSelectingLocation,
    previewMarkerPosition,
    setPreviewMarkerPosition,

    // Date mode
    dateMode,
    setDateMode,

    // Blacklist
    blacklistedFriendIds,
    setBlacklistedFriendIds,
    blacklistSearchQuery,
    setBlacklistSearchQuery,
    showBlacklist,
    setShowBlacklist,
  };
};
